const $ = jQuery;

export default class GeoRetailerMap {
    constructor(options = null) {
        this.map = null; // Define a class property for the map
        this.markers = []; // Initialize markers array at the class level
        this.AdvancedMarkerElement = null;
        this.PinElement = null;
        this.markerInfoMap = {};
        this.isLibrariesLoaded = false; // Add flag to track library loading
        // this.g = null;
        // this.__googleApi();
        this.__loadGoogleMapsLibrary();
    }

    async __loadGoogleMapsLibrary() {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        // Assign the imported classes to the class properties
        this.Map = Map;
        this.AdvancedMarkerElement = AdvancedMarkerElement;
        this.PinElement = PinElement;
        this.isLibrariesLoaded = true; // Set flag to true

        // Initialize the map now that the libraries are loaded
        await this.__geoRetailerMap();
    }

    async init() {
        // Wait for libraries to be loaded before initializing markers
        if (!this.isLibrariesLoaded) {
            // Wait a bit and check again, or you could use a proper promise
            await new Promise((resolve) => {
                const checkLoaded = () => {
                    if (this.isLibrariesLoaded) {
                        resolve();
                    } else {
                        setTimeout(checkLoaded, 100);
                    }
                };
                checkLoaded();
            });
        }
        this.__geolocateMarkers();
    }

    async __geoRetailerMap() {
        const self = this; // dealer the current instance context

        const mapContainer = document.getElementById("geo-retailer-map");

        let lat = Number(mapContainer.getAttribute("data-lat"));
        let lng = Number(mapContainer.getAttribute("data-lng"));

        if (!lat && !lng) {
            lat = 51.5229453;
            lng = -0.109285;
        }

        async function initMap() {
            if (!document.getElementById("geo-retailer-map")) {
                return;
            }

            // Ensure the Map class is available
            if (!self.Map) {
                console.error("Google Maps Map class is not available");
                return;
            }

            // Swap this out for your current geo location, currect default is london
            const position = {
                lat: lat,
                lng: lng,
            };

            self.map = new self.Map(document.getElementById("geo-retailer-map"), {
                zoom: 12,
                center: position,
                mapId: "eeb063f49df565e27d566be0",
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER, // position on map
                },
            });
        }
        await initMap(); // Make sure map is initialized

        document.body.addEventListener("click", (e) => {
            if (e.target.closest(".open-info-window")) {
                const markerId = e.target.closest(".open-info-window").dataset.markerId;
                if (markerId) {
                    this.__openInfoWindowById(markerId);
                } else {
                    console.error("No data-marker-id attribute found on clicked element.");
                }
            }
        });
    }

    __geolocateMarkers() {
        const self = this; // Capture the context of the class instance
        const coordinatesArray = [];
        const mapContainer = document.getElementById("geo-retailer-map");

        let dealerArray;

        dealerArray = JSON.parse(mapContainer.getAttribute("data-dealers"));

        const dealers = async () => {
            Object.entries(dealerArray).forEach(([key, dealer]) => {
                coordinatesArray.push({
                    lat: dealer.lat,
                    lng: dealer.lng,
                    title: dealer.name,
                    description: dealer.description,
                    address: dealer.address,
                    telephone: dealer.telephone,
                    email: dealer.email,
                    link: dealer.link,
                    type: dealer.type,
                    id: dealer.id,
                });
            });
            coordinatesArray.reverse();

            let i = 0;

            let arrayCount = coordinatesArray.length;
            let position;
            coordinatesArray.forEach((coordinate) => {
                position = {
                    lat: parseFloat(coordinate.lat),
                    lng: parseFloat(coordinate.lng),
                };

                let markerSVG;

                markerSVG = `<svg id="Group_1715" data-name="Group 1715" xmlns="http://www.w3.org/2000/svg" width="22" height="30.332" viewBox="0 0 22 30.332">
                    <g id="Group_1702" data-name="Group 1702">
                        <path id="Path_914" data-name="Path 914" d="M22,11c0,10.669-11,19.332-11,19.332S0,21.669,0,11a11,11,0,0,1,22,0" fill="#b37d45"/>
                        <circle id="Ellipse_159" data-name="Ellipse 159" cx="5.086" cy="5.086" r="5.086" transform="translate(5.914 5.778)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                    </svg>
                `;

                if (coordinate.type == "showroom") {
                    markerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="45" height="42" viewBox="0 0 45 42">
                        <g id="Group_1803" data-name="Group 1803" transform="translate(-898 -703)">
                            <g id="Group_1710" data-name="Group 1710" transform="translate(898.229 702.901)">
                            <rect id="Rectangle_759" data-name="Rectangle 759" width="45" height="35" transform="translate(-0.229 0.099)" fill="#b37d45"/>
                            <path id="Polygon_81" data-name="Polygon 81" d="M11.5,0,23,14H0Z" transform="translate(33.771 42.099) rotate(180)" fill="#b37d45"/>
                            </g>
                            <g id="Group_1711" data-name="Group 1711" transform="translate(904 709)">
                            <g id="Group_1712" data-name="Group 1712" transform="translate(0 0)">
                                <path id="Path_306" data-name="Path 306" d="M96.6,123.661l-8.612,11.823L75.474,118.3H78.6l9.389,12.887,7.048-9.666Z" transform="translate(-75.474 -112.089)" fill="#fff"/>
                                <path id="Path_307" data-name="Path 307" d="M174.824,92.659,162.305,75.474l-9.543,13.1,1.566,2.142,7.053-9.683,2.967,4.083.927-1.268,6.421,8.81Z" transform="translate(-141.816 -75.474)" fill="#fff"/>
                            </g>
                            </g>
                        </g>
                        </svg>
                    `;
                }

                self.__createMarker(position, coordinate, markerSVG);
                i++;

                if (i === arrayCount) {
                    self.__mapMarkers();
                }
            });
        };

        dealers();
    }

    __createMarker(position, coordinate, markerSVG) {
        // Add safety check
        if (!this.AdvancedMarkerElement) {
            console.error("AdvancedMarkerElement is not loaded yet");
            return;
        }

        const title = coordinate.title;

        const map = this.map;
        const parser = new DOMParser();

        const pinSvg = parser.parseFromString(markerSVG, "image/svg+xml").documentElement;

        const marker = new this.AdvancedMarkerElement({
            position,
            map,
            title,
            content: pinSvg,
        });
        this.markers.push(marker);

        const infoWindow = new google.maps.InfoWindow({
            content:
                `<div class="dealer dealer--name">${title}</div>` +
                `<div class="dealer dealer--description">${coordinate.description}</div>` +
                `<div class="dealer dealer--address">${coordinate.address}</div>` +
                `<div class="dealer dealer--telephone">${coordinate.telephone}</div>` +
                `<div class="dealer dealer--email">${coordinate.email}</div>` +
                `<a href='${coordinate.link}' target='_blank' class='dealer link button button-default'>MORE INFO</a>`,
        });

        marker.addListener("click", () => {
            // Close all other info windows
            Object.values(this.markerInfoMap).forEach(({ infoWindow }) => {
                if (infoWindow.getMap()) {
                    infoWindow.close();
                }
            });
            infoWindow.open(this.map, marker);
        });

        // dealer the marker and infoWindow in the map with the associated ID
        this.markerInfoMap[coordinate.id] = { marker, infoWindow };
    }

    __mapMarkers() {
        const mapContainer = document.getElementById("geo-retailer-map");
        const bounds = new google.maps.LatLngBounds();

        this.markers.forEach((marker) => {
            if (marker.position) {
                bounds.extend(marker.position);
            }
        });

        // Fit bounds only if more than 1 marker
        if (this.markers.length > 1) {
            this.map.fitBounds(bounds);
        } else if (this.markers.length === 1) {
            // Set center and min zoom manually for single marker
            this.map.setCenter(this.markers[0].position);
            this.map.setZoom(12); // <- adjust this to your desired minimum zoom level
        }
    }

    __openInfoWindowById(id) {
        if (this.markerInfoMap[id]) {
            const { marker, infoWindow } = this.markerInfoMap[id];
            // Close all other info windows
            Object.values(this.markerInfoMap).forEach(({ infoWindow }) => {
                if (infoWindow.getMap()) {
                    infoWindow.close();
                }
            });
            // Open the requested info window
            infoWindow.open(this.map, marker);
        } else {
            console.error(`No marker found with ID: ${id}`);
        }
    }
}
